import Handler from '@/core/domain/usecase/handler';

const getVisibleVehiclesByAccountIDRepository = (axios) => async (id) => {
    try {
        const response = await axios.get(`account/${id}/vehicle`)
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default getVisibleVehiclesByAccountIDRepository